"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLabelContainer = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _iconsReact = require("../../icons-react");

var StyledArrow = (0, _styledComponents["default"])(_iconsReact.ArrowDown).withConfig({
  displayName: "SearcherDropdownLabel__StyledArrow",
  componentId: "sc-1od0x6b-0"
})(["transform:rotate(180deg);width:13px;height:6px;path{fill:", ";}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackLight;
}, function (_ref2) {
  var opposite = _ref2.opposite;
  return opposite && "\n    transform: rotate(0deg);\n  ";
});

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdownLabel__StyledText",
  componentId: "sc-1od0x6b-1"
})(["width:100%;overflow:hidden;"]);

var StyledLabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdownLabel__StyledLabelContainer",
  componentId: "sc-1od0x6b-2"
})(["box-shadow:", ";background:", ";height:45px;padding:0 10px;display:flex;align-items:center;cursor:default;user-select:none;font-size:16px;&:hover{cursor:pointer;}", "{", "}"], function (_ref3) {
  var theme = _ref3.theme;
  return "inset 0 0 0 1px  ".concat(theme.colors.moonMist);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, StyledText, function (_ref5) {
  var open = _ref5.open,
      theme = _ref5.theme;
  return open ? "\n      color: ".concat(theme.colors.greyLight, ";\n    ") : "\n      font-weight: bold;\n    ";
});

exports.StyledLabelContainer = StyledLabelContainer;

var SearcherDropdownLabel = function SearcherDropdownLabel(_ref6) {
  var focused = _ref6.focused,
      isOpen = _ref6.isOpen,
      children = _ref6.children;
  return /*#__PURE__*/_react["default"].createElement(StyledLabelContainer, {
    focused: focused,
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(StyledText, null, children), /*#__PURE__*/_react["default"].createElement(StyledArrow, {
    opposite: isOpen ? 1 : 0
  }));
};

exports["default"] = SearcherDropdownLabel;
SearcherDropdownLabel.defaultProps = {
  children: 'Открыть'
};
SearcherDropdownLabel.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  isOpen: _propTypes["default"].bool.isRequired,
  focused: _propTypes["default"].bool.isRequired
};